
import TimeUnit from "./TimeUnit.js";
import RcMonth from "./RcMonth.js";

/** A quarter of a year, mirroring com.readychek.time.RcQuarterYear. */
export default class RcQuarterYear extends TimeUnit {

  constructor(date, timeZone) {
    super(date, timeZone);
  }

  month() {
    return new RcMonth(this.date(), this.timeZone());
  }

  value() {
    return this.month().quarterValue();
  }

  previous() {
    let month = this.month();
    const current = month.quarterValue();
    for (;;) {
      month = month.previous();
      if (month.quarterValue() !== current) {
        return new RcQuarterYear(month.date(), month.timeZone());
      }
    }
  }

  next() {
    let month = this.month();
    const current = month.quarterValue();
    for (;;) {
      month = month.next();
      if (month.quarterValue() !== current) {
        return new RcQuarterYear(month.date(), month.timeZone());
      }
    }
  }

  first() {
    let month = this.month();
    const current = month.quarterValue();
    for (;;) {
      const previous = month.previous();
      if (previous.quarterValue() !== current) {
        return month;
      }
      month = previous;
    }
  }

  last() {
    let month = this.month();
    const current = month.quarterValue();
    for (;;) {
      const next = month.next();
      if (next.quarterValue() !== current) {
        return month;
      }
      month = next;
    }
  }
}
